import React, { FC, useState } from 'react'
import styles from 'styles/components/list.module.scss'
import { Accordion, AccordionItem } from 'components/Accordion'
import { useToggleBoolean } from 'hooks/form'
import { SpecialHolidayType } from 'types/calendar'
import { parseToDate } from 'lib/helper'
import ja from 'date-fns/locale/ja'
import format from 'date-fns/format'

type Props = {
  specialHolidays: SpecialHolidayType[]
  year: string
}

const CalendarListItem: FC<Props> = React.memo((props) => {
  const { specialHolidays, year } = props

  const [isExpanded, setExpanded] = useState<boolean>(false)
  const toggleExpanded = useToggleBoolean(setExpanded)

  return (
    <Accordion handleExpand={toggleExpanded} isExpand={isExpanded} label={`${year}年`}>
      <AccordionItem>
        <ul className={styles.calendar__list}>
          {specialHolidays.map((specialHoliday) => (
            <li key={specialHoliday.date} className={styles.calendar__list__item}>
              {format(parseToDate(specialHoliday.date), 'M月d日(E)', { locale: ja })}
            </li>
          ))}
        </ul>
      </AccordionItem>
    </Accordion>
  )
})

export default CalendarListItem
